export const OAUTH_CLIENT_ID = process.env.OAUTH_CLIENT_ID || 'dms';
